module.exports = __webpack_public_path__ + "static/media/logoefe.6b0f4ff6.png";